import { categories } from '@/mocks/articles';
import { Link } from 'react-router-dom';
import SectionTitle from '@/components/base/SectionTitle';

const categoryImages: Record<string, string> = {
  'wanghong-baoliao': 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20abstract%20scene%2C%20warm%20dramatic%20lighting%2C%20minimalist%20artistic%20composition%2C%20golden%20and%20amber%20tones%2C%20editorial%20photography%20style%2C%20soft%20shadows%2C%20warm%20cream%20background&width=400&height=300&seq=cat-wanghong&orientation=landscape',
  'yule-bagua': 'https://readdy.ai/api/search-image?query=Entertainment%20news%20abstract%20scene%2C%20warm%20lighting%2C%20minimalist%20artistic%20composition%2C%20crimson%20and%20gold%20tones%2C%20editorial%20photography%20style%2C%20cinematic%20mood%2C%20soft%20shadows&width=400&height=300&seq=cat-yule&orientation=landscape',
  'meiri-dasai': 'https://readdy.ai/api/search-image?query=Competition%20abstract%20scene%2C%20warm%20dramatic%20lighting%2C%20minimalist%20artistic%20composition%2C%20gold%20and%20amber%20tones%2C%20editorial%20photography%2C%20soft%20shadows&width=400&height=300&seq=cat-meiri&orientation=landscape',
  'heiliaoneimu': 'https://readdy.ai/api/search-image?query=Mysterious%20insider%20abstract%20scene%2C%20dark%20warm%20lighting%2C%20minimalist%20artistic%20composition%2C%20crimson%20and%20dark%20gold%20tones%2C%20editorial%20photography%2C%20cinematic%20mood&width=400&height=300&seq=cat-heiliao&orientation=landscape',
  'remen-dagua': 'https://readdy.ai/api/search-image?query=Trending%20topic%20abstract%20scene%2C%20vibrant%20warm%20lighting%2C%20minimalist%20artistic%20composition%2C%20gold%20and%20red%20tones%2C%20editorial%20photography%20style%2C%20soft%20shadows&width=400&height=300&seq=cat-remen&orientation=landscape',
  'zhibo-xiuchang': 'https://readdy.ai/api/search-image?query=Live%20streaming%20abstract%20scene%2C%20warm%20dramatic%20lighting%2C%20minimalist%20artistic%20composition%2C%20amber%20and%20gold%20tones%2C%20editorial%20photography%20style%2C%20cinematic%20mood&width=400&height=300&seq=cat-zhibo&orientation=landscape',
};

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <SectionTitle
          title="分类吃瓜"
          subtitle="按口味挑选，精准找到你想吃的瓜"
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group rounded-xl overflow-hidden bg-background-100 hover:bg-background-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-32 overflow-hidden">
                <img
                  src={categoryImages[cat.slug]}
                  alt={cat.name}
                  title={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-white/20 backdrop-blur-sm mb-2">
                    <i className={`${cat.icon} text-white text-sm`}></i>
                  </div>
                  <h3 className="text-sm font-medium text-white">{cat.name}</h3>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}